import HttpRequest from './http_request'

class AcademicDataEditProvider extends HttpRequest {
  constructor() {
    super(process.env.VUE_APP_API_URL)
  }

  async getStudent(level_group, student_id) {
    const { data } = await this.get('/', {
      function: 'get-academic-data-edit-student',
      level_group,
      student_id,
    })
    return data
  }

  async getGrades({ student_type, student_id, year, semester }) {
    const { data } = await this.get('/', {
      function: 'get-academic-data-edit-grades',
      student_type,
      student_id,
      year,
      semester,
    })
    return data
  }

  async updateGrade(payload) {
    const { data } = await this.update('/', {
      function: 'update-academic-data-grade',
      ...payload,
    })
    return data
  }

  async restoreStudentStatus(payload) {
    const { data } = await this.update('/', {
      function: 'restore-academic-data-student-status',
      ...payload,
    })
    return data
  }

  async getHistory({ action = 'all', student_id = '', editor_id = '', limit = 15 }) {
    const { data } = await this.get('/', {
      function: 'get-academic-data-edit-history',
      action,
      student_id,
      editor_id,
      limit,
    })
    return data
  }
}

export default AcademicDataEditProvider
